import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from 'cccisd-modal';
import axios from 'cccisd-axios';
import Tooltip from 'cccisd-tooltip';
import notification from 'cccisd-notification';
import IconPencil from 'cccisd-icons/pencil';

import CaregiverForm from 'js/components/CaregiverForm';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;

const EditCaregiver = props => {
    const modal = useRef();
    const { row, loadData } = props;

    const onSubmit = async values => {
        const response = await axios.put(Boilerplate.route('api.nexus.pawn.update', { pawn: row['pawn.pawnId'] }), {
            pawnHash: row['pawn.pawnHash'],
            role: 'caregiver',
            caregiverName: values.caregiverName,
            caregiverPhone: values.caregiverPhone,
            caregiverEmail: values.caregiverEmail,
            caregiverLanguage: values.caregiverLanguage,
            caregiverSpecifyLanguage: values.caregiverSpecifyLanguage,
            caregiverAddress: values.caregiverAddress,
            caregiverCity: values.caregiverCity,
            caregiverState: values.caregiverState,
            caregiverZipCode: values.caregiverZipCode,
            receiveMessages: values.receiveMessages,
            group: values.site,
            childPawns: JSON.stringify(values.youth),
            parentPawns: JSON.stringify(values.careCoordinator),
        });

        if (response.data.errors) {
            let errorMessage = response.data.errors;
            if (typeof response.data.errors === 'object') {
                errorMessage = Object.values(response.data.errors).flat().join(' ');
            }
            notification({ type: 'danger', message: errorMessage });
            return Promise.reject(response.data.errors);
        }

        await loadData();
        notification({ type: 'success', message: 'Caregiver edited.' });
        await modal.current.close();
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <Tooltip title="Edit">
                    <button type="button" className="btn btn-xs btn-success">
                        <IconPencil />
                    </button>
                </Tooltip>
            }
            title="Edit Caregiver"
        >
            <CaregiverForm
                onSubmit={onSubmit}
                initialValues={{
                    caregiverName: row['fields.caregiverName'],
                    caregiverPhone: row['fields.caregiverPhone'],
                    caregiverEmail: row['fields.caregiverEmail'],
                    caregiverLanguage: row['fields.caregiverLanguage'] || 'en',
                    caregiverSpecifyLanguage: row['fields.caregiverSpecifyLanguage'],
                    caregiverAddress: row['fields.caregiverAddress'],
                    caregiverCity: row['fields.caregiverCity'],
                    caregiverState: row['fields.caregiverState'],
                    caregiverZipCode: row['fields.caregiverZipCode'],
                    receiveMessages: row['fields.receiveMessages'],
                    site: [row['ancestorGroups.site.group.groupId']],
                    youth: row['childRoles.youthList'] || [],
                    careCoordinator:
                        row['parentRoles.careCoordinator.pawn.pawnId'] !== null
                            ? [row['parentRoles.careCoordinator.pawn.pawnId']]
                            : [],
                }}
            />
        </Modal>
    );
};

EditCaregiver.propTypes = {
    loadData: PropTypes.func,
    row: PropTypes.object,
};

export default EditCaregiver;
